module.exports = __webpack_public_path__ + "static/img/posibleFondo1.506bd5af.jpg";